"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var input_card_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/input_card"));
var input_list_store_1 = __importStar(require("@hikakaku/shared/stores/estimate_form/common/input/input_list_store"));
var form_builder_validator_1 = __importDefault(require("@hikakaku/shared/validator/forms/form_builder_validator"));
var InputCardStore = /** @class */ (function () {
    function InputCardStore(props) {
        var _this = this;
        this.component = input_card_1.default;
        this.replaceInputStore = function (inputProps) {
            _this.inputListStore.replaceInputStore(inputProps);
        };
        this.findInputStoreByRawName = function (rawName) {
            return _this.inputListStore.findInputStoreByRawName(rawName);
        };
        this.validate = function () {
            return form_builder_validator_1.default.validate(_this.inputListStore) || false;
        };
        this.title = props.title;
        this.inputListStore = new input_list_store_1.default({ inputProps: props.inputProps });
    }
    Object.defineProperty(InputCardStore.prototype, "value", {
        get: function () {
            return this.inputListStore.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputCardStore.prototype, "isInputAllRequireValues", {
        get: function () {
            return this.inputListStore.inputStores.every(function (store) { return !store.necessary || Boolean(store.value); });
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_a = typeof input_list_store_1.InputListValue !== "undefined" && input_list_store_1.InputListValue) === "function" ? _a : Object),
        __metadata("design:paramtypes", [])
    ], InputCardStore.prototype, "value", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], InputCardStore.prototype, "isInputAllRequireValues", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], InputCardStore.prototype, "replaceInputStore", void 0);
    return InputCardStore;
}());
exports.default = InputCardStore;
